export const INITIAL_BANK_DETAILS = {
  accountHolderName: '',
  accountNumber: '',
  name: '',
  accountSortCode: '',
  otp: ''
};
